<template>
  <v-container class="my-10">
    <v-row>
      <v-col cols="12" md="12" class="align-self-center">
        <v-card flat>
          <v-card-text>
            <v-row justify="center" class="black--text">
              <v-col cols="12" md="12">
                <div class="mb-5">
                  <h2 class="text-md-h4 font-weight-bold sub-title-page">
                    Daya Tampung Penerimaan Mahasiswa Baru
                  </h2>
                </div>
                <div class="my-8">
                  <v-simple-table
                    fixed-header
                    dark
                    height="700px">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left" rowspan="2">
                            No
                          </th>
                          <th class="text-left" rowspan="2">
                            Kode Prodi
                          </th>
                          <th class="text-left" rowspan="2">
                            Nama Prodi
                          </th>
                          <th class="text-center" colspan="7">
                            Kuota Daya Tampung 2023
                          </th>
                        </tr>
                        <tr>
                          <th class="text-left">
                            Total
                          </th>
                          <th class="text-left">
                            SNBP
                          </th>
                          <th class="text-left">
                            % SNBP
                          </th>
                          <th class="text-left">
                            SNBT
                          </th>
                          <th class="text-left">
                            % SNBT
                          </th>
                          <th class="text-left">
                            Mandiri
                          </th>
                          <th class="text-left">
                            % Mandiri
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in datakuota" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.kdprodi }}</td>
                          <td>{{ item.prodi }}</td>
                          <td>{{ item.total }}</td>
                          <td>{{ item.snbp }}</td>
                          <td>{{ item.psnbp }}</td>
                          <td>{{ item.snbt }}</td>
                          <td>{{ item.psnbt }}</td>
                          <td>{{ item.mandiri }}</td>
                          <td>{{ item.pmandiri }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
                <div>
                  <v-divider></v-divider>
                </div>
                <div class="mb-3">
                  <div class="foot-list-content">
                    <strong class="text-subtitle-1">
                      Informasi Pengaduan Penerimaan Mahasiswa Baru:
                      <router-link :to="{ name: 'Pengaduanpmb' }">
                        Pengaduan
                      </router-link>
                    </strong>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Daayatampung',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      contact: false,
      regnew: false,
    },
    api: process.env.VUE_APP_API,
    apptitle: process.env.VUE_APP_TITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    publickey: '123',
    contact: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    datakuota: [
      {
        kdprodi: '617001',
        prodi: 'MANAJEMEN PROYEK KONSTRUKSI',
        total: '150',
        snbp: '38',
        psnbp: '25,33 %',
        snbt: '68',
        psnbt: '45,33 %',
        mandiri: '44',
        pmandiri: '29,33 %',
      },
      {
        kdprodi: '617002',
        prodi: 'TEKNOLOGI REKAYASA UTILITAS',
        total: '60',
        snbp: '15',
        psnbp: '25,00 %',
        snbt: '27',
        psnbt: '45,00 %',
        mandiri: '18',
        pmandiri: '30,00 %',
      },
      {
        kdprodi: '617003',
        prodi: 'TEKNIK OTOMASI',
        total: '90',
        snbp: '23',
        psnbp: '25,56 %',
        snbt: '41',
        psnbt: '45,56 %',
        mandiri: '26',
        pmandiri: '28,89 %',
      },
    ],
    word: 'Vue',
    dmodal: {
      register: false,
    },
    regflag: false,
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    // console.log('1');
  },
  methods: {
    submitContact() {
      this.alertdata.show = false;
      if (this.$refs.formcontact.validate()) {
        this.loading.contact = true;
        this.axios
          .post(
            this.api + '/public/contact',
            qs.stringify(
              this.contact,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            this.alertdata.show = true;
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data === 1) {
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Thank you for getting in touch!';
                } else {
                  this.alertdata.type = 'error';
                  this.alertdata.text = 'Sorry we get error in your sending email, please try again!';
                }
              } else {
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.contact = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.contact = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
